export const baseUrl = 'https://resources.jctrans.com/res/era-h5/h5/img'

export const noMemberShopBannerURL = `${baseUrl}/banner_nomember.jpg`

export const VideoSelected = `${baseUrl}/icon_video_selected.png`
export const VideoUnselected = `${baseUrl}/icon_video_nor.png`
export const BannerSelected = `${baseUrl}/icon_pic_selected.png`
export const BannerUnselected = `${baseUrl}/icon_pic_nor.png`

export const IconAdvanNor = `${baseUrl}/icon_advan_nor.png`
export const IconAirPartnerNor = `${baseUrl}/icon_air%20partner_nor.png`
export const IconAirAdvanNor = `${baseUrl}/icon_airadvan_nor.png`
export const IconPolNor = `${baseUrl}/icon_pol_nor.png`
export const IconSeaAdvanNor = `${baseUrl}/icon_seaadvan_nor.png`
export const IconShipPartnerNor = `${baseUrl}/icon_shippartner_nor.png`

export const IconAdvanPopup = `${baseUrl}/icon_advan_popup.png`
export const IconAirAdvanPopup = `${baseUrl}/icon_airadvan_popup.png`
export const IconAirPartnerPopup = `${baseUrl}/icon_airpartner_popup.png`
export const IconPolPopup = `${baseUrl}/icon_pol_popup.png`
export const IconSeaAdvanPopup = `${baseUrl}/icon_seaadvan_popup.png`
export const IconShipPartnerPopup = `${baseUrl}/icon_shippartner_popup.png`

export const IconClosePopupNor = `${baseUrl}/icon_close.png`

export const IconTo = `${baseUrl}/icon_to.png`

export const IconMoreNor = `${baseUrl}/icon_more_nor.png`

export const IconAddress = `${baseUrl}/icon_address.png`
export const IconEnterpriseSize = `${baseUrl}/icon_enterprisesize.png`
export const IconEstablish = `${baseUrl}/icon_establish.png`
export const IconLocation = `${baseUrl}/icon_location.png`
export const IconWebsite = `${baseUrl}/icon_establish.png`

export const IconAvatar = `${baseUrl}/icon_avatar.png`
export const IconMail = `${baseUrl}/icon_mail.png`
export const IconMessager = `${baseUrl}/icon_messager.png`
export const IconPhone = `${baseUrl}/icon_phone.png`
export const IconQQ = `${baseUrl}/icon_qq.png`
export const IconSkype = `${baseUrl}/icon_Skype.png`
export const IconWechat = `${baseUrl}/icon_wechat.png`
export const IconWhatsapp = `${baseUrl}/icon_whatsapp.png`

export const IconContact = `${baseUrl}/icon_getcontact.png`

export const IconMoreBlue = `${baseUrl}/icon_more_blue.png`
export const IconLogoCredit = `${baseUrl}/logo_credit.png`
export const IconLogoLiabilityInsurance = `${baseUrl}/logo_liability_insurance.png`
export const IconLogoLiabilityInsuranceList = `${baseUrl}/logo_liability_insurance_list_icon.png`

export const IconSchedule = `${baseUrl}/icon_schedule.png`
export const IconHistory = `${baseUrl}/icon_history.png`

export const IconPlay = `${baseUrl}/icon_play_12.png`

// 会员证书底图
export const IconCertificateDg = `${baseUrl}/tag_certificate_dg.png`
export const IconCertificateEc = `${baseUrl}/tag_certificate_ec.png`
export const IconCertificateElite = `${baseUrl}/tag_certificate_elite.png`
export const IconCertificatePre = `${baseUrl}/tag_certificate_pre.png`
export const IconCertificatePro = `${baseUrl}/tag_certificate_pro.png`
export const IconCertificateRailway = `${baseUrl}/tag_certificate_railway.png`
export const IconCertificateRising = `${baseUrl}/tag_certificate_rising.png`
export const IconCertificateVendor = `${baseUrl}/tag_certificate_vendor.png`

export const IconCheckboxSelectedNo = `${baseUrl}/checkbox_selected_no.png`
export const IconCheckboxSelectedYes = `${baseUrl}/checkbox_selected_yes.png`

export const IconArrowLeft = `${baseUrl}/icon_arrow_left.png`
export const IconArrowRight = `${baseUrl}/icon_arrow_right.png`

export const IconTagMemberDangerousL = `${baseUrl}/tag_member_dangerous_l@2x.png`
export const IconTagMemberEcommerceL = `${baseUrl}/tag_member_ecommerce_l@2x.png`
export const IconTagMemberEliteL = `${baseUrl}/tag_member_elite_l@2x.png`
export const IconTagMemberPremiumL = `${baseUrl}/tag_member_premium_l@2x.png`
export const IconTagMemberProjectL = `${baseUrl}/tag_member_project_l@2x.png`
export const IconTagMemberRailwayL = `${baseUrl}/tag_member_railway_l@2x.png`
export const IconTagMemberRisingL = `${baseUrl}/tag_member_rising_l@2x.png`
export const IconTagMemberVendorL = `${baseUrl}/tag_member_vendor_l@2x.png`

export const IconAlertSelected = `${baseUrl}/icon_alert_selected.png`
export const IconAlertUnSelected = `${baseUrl}/icon_alert_nor.png`

export const IconCertificatesNor = `${baseUrl}/icon_certificates_nor.png`
export const IconCertificatesPopup = `${baseUrl}/icon_certificates_popup.png`

export const IconServiceFeaturesNor = `${baseUrl}/icon_service_features_nor.png`
export const IconServiceFeaturesPopup = `${baseUrl}/icon_service_features_popup.png`

export const IconAdvDisLike =
  'https://resources.jctrans.com/res/era-h5/h5/img/icon_like_nor_nor@2x.png'
export const IconAdvLike =
  'https://resources.jctrans.com/res/era-h5/h5/img/icon_like_nor_selected@2x.png'

export const jcvfLikePng =
  'https://resources.jctrans.com/res/era-h5/h5/img/icon_like_jcvf_selected@2x.png'
export const jcvfDisLikePng =
  'https://resources.jctrans.com/res/era-h5/h5/img/icon_like_jcvf_nor@2x.png'

/**
 * 服务范围列表
 */
export const ServiceScopeList = [
  {
    name: 'membershipList.serviceScope.advantages',
    icon: IconAdvanNor,
    iconPopup: IconAdvanPopup,
    list: [],
    code: 'advantages', // 优势
  },
  {
    name: 'membershipList.serviceScope.advantagePort',
    icon: IconPolNor,
    iconPopup: IconPolPopup,
    list: [
      // 'AA America',
      // 'Vietnam-Europe America',
      // 'Vietnam-Asia',
      // 'Vietnam-Africa',
      // 'Vietnam-South America',
      // 'Vietnam-Middle East',
      // 'Vietnam-Australia',
      // 'Vietnam-Oceania',
    ],
    code: 'seaportNames', // 港口优势
  },
  {
    name: 'membershipList.serviceScope.seaFreightAdvantageous',
    icon: IconSeaAdvanNor,
    iconPopup: IconSeaAdvanPopup,
    list: [],
    code: 'seaLines', // 海运优势
  },
  {
    name: 'membershipList.serviceScope.airFreightAdvantageous',
    icon: IconAirAdvanNor,
    iconPopup: IconAirAdvanPopup,
    list: [],
    code: 'airLines', // 空运优势
  },
  {
    name: 'membershipList.serviceScope.shippingPartners',
    icon: IconShipPartnerNor,
    iconPopup: IconShipPartnerPopup,
    list: [],
    code: 'shippingNames', // 航司
  },
  {
    name: 'membershipList.serviceScope.airPartners',
    icon: IconAirPartnerNor,
    iconPopup: IconAirPartnerPopup,
    list: [],
    code: 'airNames', // 航司
  },
  {
    name: 'membershipList.serviceScope.certificates',
    icon: IconCertificatesNor,
    iconPopup: IconCertificatesPopup,
    list: [],
    code: 'eraCertificatesVoList', // 证书
  },
  // JCVF 2期 取消服务特色子模块展示
  // {
  //   name: 'membershipList.serviceScope.serviceFeatures',
  //   icon: IconServiceFeaturesNor,
  //   iconPopup: IconServiceFeaturesPopup,
  //   list: [],
  //   code: 'serviceFeatures', // 服务特性
  // },
]

/**
 * 可以被点赞的列表
 */
export const likeList = [
  'membershipList.serviceScope.advantages',
  'membershipList.serviceScope.advantagePort',
  'membershipList.serviceScope.seaFreightAdvantageous',
  'membershipList.serviceScope.airFreightAdvantageous',
]

/**
 * 会员标签列表
 */
export const memberTagList = [
  {
    url: `${baseUrl}/tag_member_dg_16.png`,
    color: '#D80E0E',
    name: 'dangerous',
    code: 'JC Dangerous Goods',
    shopBannerURL: `${baseUrl}/banner_dg.jpg`,
    certificateUrl: IconCertificateDg,
    popupUrl: IconTagMemberDangerousL,
    skinCode: 'jsdangerousgoods0',
  }, // JC Dangerous Goods
  {
    url: `${baseUrl}/tag_member_ec_16.png`,
    color: '#3C35C4',
    name: 'ecommerce',
    code: 'JC eCommerce',
    shopBannerURL: `${baseUrl}/banner_ec.jpg`,
    certificateUrl: IconCertificateEc,
    popupUrl: IconTagMemberEcommerceL,
    skinCode: 'jsecommerce0',
  }, // JC e-Commerce
  {
    url: `${baseUrl}/tag_member_elite_16.png`,
    color: '#4A2D13',
    name: 'elite',
    code: 'JC Elite',
    shopBannerURL: `${baseUrl}/banner_jce.jpg`,
    certificateUrl: IconCertificateElite,
    popupUrl: IconTagMemberEliteL,
    skinCode: 'jcelite0',
  }, // JC Elite
  {
    url: `${baseUrl}/tag_member_premium_16.png`,
    color: '#EC661B',
    name: 'premium',
    code: 'GCP',
    shopBannerURL: `${baseUrl}/banner_pre.jpg`,
    certificateUrl: IconCertificatePre,
    popupUrl: IconTagMemberPremiumL,
    skinCode: 'jcpremium0',
  }, // JC Premium
  {
    url: `${baseUrl}/tag_member_project_16.png`,
    color: '#003BB9',
    name: 'project',
    code: 'JC Projects',
    shopBannerURL: `${baseUrl}/banner_pro.jpg`,
    certificateUrl: IconCertificatePro,
    popupUrl: IconTagMemberProjectL,
    skinCode: 'jcprojects0',
  }, // JC Projects
  {
    url: `${baseUrl}/tag_member_railway_16.png`,
    color: '#825034',
    name: 'railway',
    code: 'JC Railway',
    shopBannerURL: `${baseUrl}/banner_railway.jpg`,
    certificateUrl: IconCertificateRailway,
    popupUrl: IconTagMemberRailwayL,
    skinCode: 'jcrailway0',
  }, // JC Railway
  {
    url: `${baseUrl}/tag_member_rising_16.png`,
    color: '#396F09',
    name: 'rising',
    code: 'GRP',
    shopBannerURL: `${baseUrl}/banner_rising.jpg`,
    certificateUrl: IconCertificateRising,
    popupUrl: IconTagMemberRisingL,
    skinCode: 'jcrising0',
  }, // JC Rising
  {
    url: `${baseUrl}/tag_member_vendor_16.png`,
    color: '#265438',
    name: 'vendor',
    code: 'JC Vendor',
    shopBannerURL: `${baseUrl}/banner_v.jpg`,
    certificateUrl: IconCertificateVendor,
    popupUrl: IconTagMemberVendorL,
    skinCode: 'jcvendor0',
  }, // JC Vendor | JC Vendor Consulting Services | JC Vendor Finance Services | JC Vendor IT Services | JC Vendor Transportation | JC Vendor Warehousing
]

/**
 * 公司资料列表
 */
export const companyProfileInfoList = [
  {
    name: 'membershipList.company.location',
    icon: IconLocation,
    code: 'Location',
    text: '',
  },
  {
    name: 'membershipList.company.address',
    icon: IconAddress,
    code: 'Address',
    text: '',
  },
  {
    name: 'membershipList.company.establishedDate',
    icon: IconEstablish,
    code: 'Established Date',
    text: '',
  },
  {
    name: 'membershipList.company.enterpriseSize',
    icon: IconEnterpriseSize,
    code: 'Enterprise Size',
    text: '',
  },
  {
    name: 'membershipList.company.website',
    icon: IconWebsite,
    code: 'Website',
    text: '',
  },
]

export const defaultFilterDictRecords = {
  msg: '操作成功',
  code: 0,
  data: {
    advantageDicts: [
      {
        labelCn: '空运',
        labelEn: 'Air Freight',
        value: 'Air Freight',
      },
      {
        labelCn: '多式联运',
        labelEn: 'Intermodal',
        value: 'Intermodal',
      },
      {
        labelCn: '快递',
        labelEn: 'Express',
        value: 'Express',
      },
      {
        labelCn: 'FBA',
        labelEn: 'FBA',
        value: 'FBA',
      },
      {
        labelCn: '散杂',
        labelEn: 'Break Bulk',
        value: 'Break Bulk',
      },
      {
        labelCn: '卡车',
        labelEn: 'Truck',
        value: 'Truck',
      },
      {
        labelCn: '冷藏柜',
        labelEn: 'Reefer Container',
        value: 'Reefer Container',
      },
      {
        labelCn: '集中托运人',
        labelEn: 'Consolidator',
        value: 'Consolidator',
      },
      {
        labelCn: '海运整箱',
        labelEn: 'FCL',
        value: 'FCL',
      },
      {
        labelCn: '海运拼箱',
        labelEn: 'LCL',
        value: 'LCL',
      },
      {
        labelCn: '危险品',
        labelEn: 'Hazardous Cargo',
        value: 'Hazardous Cargo',
      },
      {
        labelCn: '铁路',
        labelEn: 'Rail',
        value: 'Rail',
      },
      {
        labelCn: '仓储',
        labelEn: 'Warehousing',
        value: 'Warehousing',
      },
      {
        labelCn: '清关',
        labelEn: 'Customs Clearance',
        value: 'Customs Clearance',
      },
      {
        labelCn: '特种柜',
        labelEn: 'Special Container',
        value: 'Special Container',
      },
    ],
    memberShipDicts: [
      {
        labelCn: 'JC Elite',
        labelEn: 'JC Elite',
        value: 'JC Elite',
      },
      {
        labelCn: 'JC Dangerous Goods',
        labelEn: 'JC Dangerous Goods',
        value: 'JC Dangerous Goods',
      },
      {
        labelCn: 'JC Premium',
        labelEn: 'JC Premium',
        value: 'GCP',
      },
      {
        labelCn: 'JC e-Commerce',
        labelEn: 'JC e-Commerce',
        value: 'JC eCommerce',
      },
      {
        labelCn: 'JC Rising',
        labelEn: 'JC Rising',
        value: 'GRP',
      },
      {
        labelCn: 'JC Railway',
        labelEn: 'JC Railway',
        value: 'JC Railway',
      },
      {
        labelCn: 'JC Projects',
        labelEn: 'JC Projects',
        value: 'JC Projects',
      },
      {
        labelCn: 'JC Vendor',
        labelEn: 'JC Vendor',
        value: 'JC Vendor',
      },
    ],
    certificateDicts: [
      {
        labelCn: 'NVOCC',
        labelEn: 'NVOCC',
        value: '1',
      },
      {
        labelCn: 'IATA',
        labelEn: 'IATA',
        value: '2',
      },
      {
        labelCn: 'FIATA',
        labelEn: 'FIATA',
        value: '3',
      },
      {
        labelCn: 'AEO',
        labelEn: 'AEO',
        value: '4',
      },
      {
        labelCn: 'ISO 9001',
        labelEn: 'ISO 9001',
        value: '5',
      },
      {
        labelCn: '营业执照',
        labelEn: 'Certificate of business',
        value: '6',
      },
      {
        labelCn: '其他',
        labelEn: 'Other',
        value: '7',
      },
      {
        labelCn: 'TAPA',
        labelEn: 'TAPA',
        value: '8',
      },
      {
        labelCn: 'FMC',
        labelEn: 'FMC',
        value: '9',
      },
      {
        labelCn: '货代责任险',
        labelEn: 'liability insurance',
        value: '10',
      },
    ],
    airLineDicts: [
      {
        labelCn: '中东印巴线',
        labelEn: 'Middle East-India-Pakistan',
        value: 20000025,
      },
      {
        labelCn: '日韩线',
        labelEn: 'Japan-Korea',
        value: 20000024,
      },
      {
        labelCn: '西非线',
        labelEn: 'West Africa',
        value: 20000035,
      },
      {
        labelCn: '西北欧线',
        labelEn: 'North-Western Europe',
        value: 20000027,
      },
      {
        labelCn: '北非线',
        labelEn: 'North Africa',
        value: 20000026,
      },
      {
        labelCn: '澳新线',
        labelEn: 'Australia-New Zealand',
        value: 20000018,
      },
      {
        labelCn: '南非线',
        labelEn: 'South Africa',
        value: 20000029,
      },
      {
        labelCn: '俄罗斯远东线',
        labelEn: 'Russian Far East',
        value: 20000028,
      },
      {
        labelCn: '中亚地区',
        labelEn: 'Central Asia',
        value: 20000019,
      },
      {
        labelCn: '东南亚线',
        labelEn: 'Southeast Asia',
        value: 20000030,
      },
      {
        labelCn: '中国大陆线',
        labelEn: 'China Mainland',
        value: 20000021,
      },
      {
        labelCn: '地中海线',
        labelEn: 'The Mediterranean',
        value: 20000032,
      },
      {
        labelCn: '中南美线',
        labelEn: 'Central-South America',
        value: 20000020,
      },
      {
        labelCn: '黑海线',
        labelEn: 'The Black Sea',
        value: 20000031,
      },
      {
        labelCn: '中国港澳台线',
        labelEn: 'HK-Macao-Taiwan (China)',
        value: 20000023,
      },
      {
        labelCn: '美加线',
        labelEn: 'United States-Canada',
        value: 20000034,
      },
      {
        labelCn: '东非线',
        labelEn: 'East Africa',
        value: 20000022,
      },
      {
        labelCn: '红海线',
        labelEn: 'The Red Sea',
        value: 20000033,
      },
    ],
    shippingLineDicts: [
      {
        labelCn: '东南亚线',
        labelEn: 'Southeast Asia',
        value: 20000003,
      },
      {
        labelCn: '南非线',
        labelEn: 'South Africa',
        value: 20000014,
      },
      {
        labelCn: '吃吃吃此',
        labelEn: 'Aaa',
        value: 20000047,
      },
      {
        labelCn: '日韩线',
        labelEn: 'Japan-Korea',
        value: 20000002,
      },
      {
        labelCn: '东非线',
        labelEn: 'East Africa',
        value: 20000013,
      },
      {
        labelCn: '俄罗斯远东线',
        labelEn: 'Russian Far East',
        value: 20000005,
      },
      {
        labelCn: '美加线',
        labelEn: 'United States-Canada',
        value: 20000016,
      },
      {
        labelCn: '澳新线',
        labelEn: 'Australia-New Zealand',
        value: 20000004,
      },
      {
        labelCn: '西非线',
        labelEn: 'West Africa',
        value: 20000015,
      },
      {
        labelCn: '吱吱吱吱',
        labelEn: 'Zzzz',
        value: 20000048,
      },
      {
        labelCn: '中东印巴线',
        labelEn: 'Middle East-India-Pakistan',
        value: 20000007,
      },
      {
        labelCn: '中亚地区',
        labelEn: 'Central Asia',
        value: 20000006,
      },
      {
        labelCn: '中南美线',
        labelEn: 'Central-South America',
        value: 20000017,
      },
      {
        labelCn: '测试关联城市',
        labelEn: 'ENENEN',
        value: 20000039,
      },
      {
        labelCn: '黑海线',
        labelEn: 'The Black Sea',
        value: 20000009,
      },
      {
        labelCn: '红海线',
        labelEn: 'The Red Sea',
        value: 20000008,
      },
      {
        labelCn: '地中海线',
        labelEn: 'The Mediterranean',
        value: 20000010,
      },
      {
        labelCn: '中国港澳台线',
        labelEn: 'HK-Macao-Taiwan (China)',
        value: 20000001,
      },
      {
        labelCn: '北非线',
        labelEn: 'North Africa',
        value: 20000012,
      },
      {
        labelCn: '中国大陆线',
        labelEn: 'China Mainland',
        value: 20000000,
      },
      {
        labelCn: '西北欧线',
        labelEn: 'North-Western Europe',
        value: 20000011,
      },
    ],
  },
}

/** H5 SEM 落地页注册入口：点击入口按钮时写入 sessionStorage，注册时作为 formEntry 提交 */
export const SEM_REGISTER_ENTRY_KEY = 'H5SEM_REGISTER_ENTRY'
export const SEM_REGISTER_ENTRY_DEFAULT = 'H5SEM-表单直接注册'
